<template>
  <div class="popup-form client-data-popup">

    <div
      class="content-form-popup client-data-popup-content"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <app-icon name="close" :size="24" />
        </div>
        <div class="blackcolor pop-800">Údaje klienta</div>
        <button form="client-profile" class="w-button saveformBtn">Uložiť</button>
      </div>
      <div class="header-block inline" v-if="clientInfo.type">
        <div class="bold">{{ clientInfo.type }}</div>
        <img
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
          loading="lazy"
          alt=""
          class="image-10"
        />
      </div>
      <div class="client-data-tabs" role="tablist" aria-label="Sekcie údajov klienta">
        <button
          type="button"
          class="client-data-tab"
          :class="{active: activeSection === 'personal'}"
          role="tab"
          :aria-selected="activeSection === 'personal'"
          @click="activeSection = 'personal'"
        >
          Osobné údaje
        </button>
        <button
          type="button"
          class="client-data-tab"
          :class="{active: activeSection === 'bonita'}"
          role="tab"
          :aria-selected="activeSection === 'bonita'"
          @click="activeSection = 'bonita'"
        >
          Bonita
        </button>
      </div>
      <div class="client-data-form-wrapper">
        <personal-info-form
          :client="payload"
          :errors="errors"
          :active-section="activeSection"
          @client-saved="saveClient($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInfoForm from "./PersonalInfoForm";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ClientPersonalInfoPopUp",
  components: {AppIcon, PersonalInfoForm},
  props: {
    payload: [Object, null],
  },
  created () {
    this.clientInfo = this.payload.clientInfo;
  },
  methods: {
    async saveClient (clientSavedObject) {
      const mortgageChildren = clientSavedObject.mortgageChildren;
      delete clientSavedObject.mortgageChildren;
      clientSavedObject.clientInfo.type = this.clientInfo.type;

      let successMessageLabel = null;
      if (this.payload.clientInfo.type) {
        successMessageLabel = `${this.payload.clientInfo.type}ove údaje boli aktualizované`;
      } else {
        successMessageLabel = "Klientove údaje boli aktualizované";
      }
      clientSavedObject.successMessage = successMessageLabel;

      try {
        if (mortgageChildren) {
          await this.$store.dispatch("mortgageDetailState/saveMortgageChildren", mortgageChildren);
        }
        await this.$store.dispatch("mortgageDetailState/patchClientProfile", clientSavedObject);
        this.$store.commit("popupManagerState/setUserManagerRefresh", true);
      } catch (error) {
        this.errors = error?.response?.data || {
          detail: ["Údaje klienta sa nepodarilo uložiť."],
        };
      }
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    activeSection: "bonita",
    clientInfo: null,
    errors: {},
  }),
};
</script>

<style scoped lang="scss">

.client-data-popup {
  overflow-x: hidden;
}

.back-button-wrapper {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
}

.client-data-popup-content {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
}

.client-data-popup-content > *,
.client-data-form-wrapper {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
}

.client-data-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  box-sizing: border-box;
  width: 100%;
  margin: 4px 0 24px;
  padding: 6px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface-muted);
}

.client-data-tab {
  min-width: 0;
  padding: 12px 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--app-text-muted);
  font-weight: 700;
  cursor: pointer;
}

.client-data-tab:focus-visible {
  outline: 2px solid #2d7dd2;
  outline-offset: 2px;
}

.client-data-tab.active {
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.popup {
  width: 34%;
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}
</style>
